/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddSupplierDto as DigiworkMaitreDPosDtoSuppliersAddSupplierDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Suppliers/add-supplier-dto';
import { SupplierDto as DigiworkMaitreDPosDtoSuppliersSupplierDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Suppliers/supplier-dto';

export interface NewSupplier$Params {
      body?: DigiworkMaitreDPosDtoSuppliersAddSupplierDto
}

export function newSupplier(http: HttpClient, rootUrl: string, params?: NewSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>> {
  const rb = new RequestBuilder(rootUrl, newSupplier.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>;
    })
  );
}

newSupplier.PATH = '/api/suppliers';
